<!-- qiandao -->
<template>
  <div class="signInMode">
    <el-dialog
      custom-class="mainDialogStyle"
      width="841px"
      :show-close="false"
      :visible.sync="dialogVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="signInMode_diaog">
        <div class="top">
          <div class="left">
            <div class="left_t1">
              已领取 <span>{{ singSum }}</span> 张
            </div>
            <div class="left_t2">
              （剩余 <span>{{ noSingSun }}</span> 天）
            </div>
          </div>
          <div class="right">
            <img
              @click="step('prev')"
              src="@/assets/image/icon_left.webp"
              alt=""
              srcset=""
            />
            <div class="right_c">
              <span>{{ page }}</span> / 3
            </div>
            <img
              @click="step('next')"
              src="@/assets/image/icon_right.webp"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div class="content">
          <div class="box">
            <signinItem
              v-for="item in list"
              :key="item.checkInId"
              :itemData="{ ...item, type: renderType(item)}"
              @sing="sing"
            />
          </div>
          <el-button
            class="button"
            type="primary"
            :disabled="buttonDisabled()"
            @click="sing"
            >{{buttonDisabled()?'今日已签':'签到领取奖励'}}</el-button
          >
          <div class="desc">剩余{{ noSingSun }}天结束</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import signinItem from "./signinItem.vue";
const now = new Date();
export default {
  components: { signinItem },
  data() {
    return {
      dialogVisible: false,
      page: 3,
      checkInList: [],
      singSum: 0,
      noSingSun: 0,
      singDate: "",
      show: true,
      todayTimestamp: Math.floor(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) / 1000
      ),
    };
  },
  created() {},
  computed: {
    list() {
      // 分页
      if (this.page == 1) {
        return this.checkInList.slice(0, 30);
      } else if (this.page == 2) {
        return this.checkInList.slice(30, 60);
      } else {
        return this.checkInList.slice(60, 90);
      }
    },
  },
  methods: {
    onshow() {
      this.getCheckInList();
    },
    step(type) {
      if (type == "next") {
        if (this.page == 3) return;
        this.page++;
      } else {
        if (this.page == 1) return;
        this.page--;
      }
    },
    async getCheckInList() {
      const { data, info, status } = await this.$api.getCheckInList();
      if (status === 200) {
        this.checkInList = data.map((res,idx)=>({...res,day:idx+1}));
        this.initInfo();
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
    renderType(item) {
      // type == 1 已签到 type == 2 未签到  type == 3 点击签到  type == 4 未到签到时间
      const isToday =
        new Date(item.timeWindow * 1000).toDateString() === new Date().toDateString();
      if (item.checkedInAt) {
        return 1;
      }
      if (isToday) {
        return 3;
      }

      if (item.timeWindow > this.todayTimestamp) {
        return 4;
      }
      return 2;
    },
    initPage() {
      // 给定的数据
      const data = this.checkInList;

      // 遍历数据，找到与当前时间匹配的 timeWindow
      let page = null;
      for (const item of data) {
        if (
          item.timeWindow <= this.todayTimestamp &&
          this.todayTimestamp < item.timeWindow + 86400
        ) {
          // 86400秒是一天
          // 根据 checkInId 确定页面
          if (item.checkInId >= 1 && item.checkInId <= 30) {
            page = 1;
          } else if (item.checkInId >= 31 && item.checkInId <= 60) {
            page = 2;
          } else if (item.checkInId >= 61 && item.checkInId <= 90) {
            page = 3;
          }
          break; // 找到匹配项后退出循环
        }
      }
      this.page = page || 1; // 如果没有找到匹配项，默认为第一页
    },
    sing() {
      this.dialogVisible = false;
      this.$emit("sing");
    },
    buttonDisabled() {
      const todayCheckIn = this.checkInList.find((item) => {
        const isToday =
          new Date(item.timeWindow * 1000).toDateString() === new Date().toDateString();
        return isToday && item.checkedInAt;
      });
      return !!todayCheckIn;
    },
    // 初始化数据
    initInfo() {
      if (this.checkInList.length == 0) {
        this.$message({
          type: "error",
          message: "暂无签到数据",
        });
        return;
      }
      this.initPage();
      this.singSum = this.checkInList.filter((item) => item.checkedInAt).length;
      this.noSingSun = this.checkInList.filter(
        (item) => item.timeWindow >= this.todayTimestamp && item.checkedInAt === null
      ).length;
      this.singDate = `${this.$utils.timeFormat(
        this.checkInList[0].timeWindow,
        "mm月dd日"
      )}-${this.$utils.timeFormat(
        this.checkInList[this.checkInList.length - 1].timeWindow,
        "mm月dd日"
      )}`;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.signInMode {
  @include dialog860Style;
  background-color: transparent;
  &_diaog {
    // margin-top: calc((100vh - 595px) / 2);
    background-image: url(~@/assets/image/qiandao.webp);
    background-color: transparent;
    background-size: 100% auto;
    height: 742px;
    background-repeat: no-repeat;
    position: relative;
    padding-top: 200px;
    $padding: calc(841px - 820px) / 2;
    padding-left: $padding;
    padding-right: $padding;
    .top {
      width: 820px;
      height: 60px;
      display: flex;
      padding: 0 20px;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        font-size: 18px;
        font-weight: bold;
        &_t1 {
          color: #262626;

          span {
            color: #0062ff;
          }
        }
        &_t2 {
          color: #999999;
          span {
            color: #0062ff;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        gap: 10px;

        font-size: 20px;
        color: #999999;
        span {
          color: #0062ff;
        }
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
    }
    .content {
      height: calc(100% - 60px);
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .box {
        width: 100%;
        height: calc(114px * 3 + 16px * 2);
        display: grid;
        grid-template-columns: repeat(10, 1fr); /* 10 列 */
        grid-template-rows: repeat(3, auto); /* 3 行 */
        column-gap: 0; /* 列间距为 0 */
        row-gap: 16px; /* 行间距为 16px */
      }
      .button {
        width: 264px;
        height: 40px;
        margin-top: 20px;
      }
      .desc {
        font-size: 14px;
        color: #999999;
        margin-top: 10px;
      }
    }
    // &_top {
    //   height: 100px;
    //   padding: 0 30px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   .left {
    //     .left_t {
    //       color: #262626;
    //       font-family: "Noto Sans SC";
    //       font-size: 20px;
    //       font-style: normal;
    //       font-weight: 800;
    //       line-height: normal;
    //     }
    //     .left_b {
    //       color: #666;
    //       font-family: "Noto Sans SC";
    //       font-size: 16px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //     }
    //   }
    //   .right {
    //     color: #333;
    //     font-family: "Noto Sans SC";
    //     font-size: 16px;
    //     font-style: normal;
    //     font-weight: 400;
    //     line-height: normal;
    //   }
    // }
    // &_content {
    //   width: 900px;
    //   height: 626px;
    //   border-radius: 20px;
    //   // background: rgba(255, 255, 255, 0.8);
    //   box-shadow: -2px 2px 0px 0px #fff inset, 2px 2px 0px 0px #fff inset,
    //     0px 2px 0px 0px #fff inset, 0px 6px 20px 0px rgba(0, 0, 0, 0.04);
    //   backdrop-filter: blur(7.5px);
    //   margin: 0 auto;
    //   &_header {
    //     height: 60px;
    //     display: flex;
    //     align-items: center;
    //     padding-left: 30px;
    //     .left {
    //       color: #333;
    //       font-family: "Noto Sans SC";
    //       font-size: 18px;
    //       font-style: normal;
    //       font-weight: 700;
    //       line-height: normal;
    //     }
    //     .right {
    //       color: #999;
    //       font-family: "Noto Sans SC";
    //       font-size: 18px;
    //       font-style: normal;
    //       font-weight: 700;
    //       line-height: normal;
    //     }
    //     .red {
    //       color: #fe3766;
    //       font-family: "Noto Sans SC";
    //       font-size: 18px;
    //       font-style: normal;
    //       font-weight: 700;
    //       line-height: normal;
    //     }
    //   }
    //   &_table {
    //     padding: 0 30px;
    //     display: flex;
    //     gap: 10px; /* 行和列的间距都是 10px */
    //     flex-wrap: wrap;
    //     .item {
    //       display: flex;
    //       align-items: center;
    //       justify-content: center;
    //       flex-direction: column;
    //       width: 96px;
    //       height: 128px;
    //       flex-shrink: 0;
    //       border-radius: 10px;
    //       img {
    //         margin: 10px 0;
    //       }
    //       &_top {
    //       }
    //       &_center {
    //       }
    //       &_bottom {
    //       }
    //     }
    //     .item1 {
    //       background: #ffeef1;
    //       color: #000;
    //       font-family: "Noto Sans SC";
    //       font-size: 14px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //     }
    //     .item2 {
    //       border-radius: 10px;
    //       border: 1.5px dashed #fe3766;
    //       background: #f6f7f8;
    //       color: #999;
    //       font-family: "Noto Sans SC";
    //       font-size: 14px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //     }
    //     .item3 {
    //       border-radius: 10px;
    //       background: linear-gradient(180deg, #fd4489 0%, #fd5d6a 100%);
    //       box-shadow: 0px 4px 10px 0px rgba(254, 55, 102, 0.2);
    //       color: #fff;
    //       font-family: "Noto Sans SC";
    //       font-size: 14px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //       cursor: pointer;
    //     }
    //     .item4 {
    //       border-radius: 10px;
    //       background: #f6f7f8;
    //       color: #999;
    //       font-family: "Noto Sans SC";
    //       font-size: 14px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //     }
    //     .lastbutton1 {
    //       width: 202px;
    //       height: 132px;
    //       flex-shrink: 0;
    //       border-radius: 10px;
    //       background: #f6f7f8;
    //       color: #0062ff;
    //       font-family: "Noto Sans SC";
    //       font-size: 16px;
    //       font-style: normal;
    //       font-weight: 400;
    //       line-height: normal;
    //       display: flex;
    //       align-items: center;
    //       justify-content: center;
    //       cursor: pointer;
    //     }
    //     .lastbutton2 {
    //       display: flex;
    //       gap: 10px; /* 行和列的间距都是 10px */
    //       .item {
    //         border-radius: 10px;
    //         background: #f6f7f8;
    //         cursor: pointer;
    //         p {
    //           color: #0062ff;
    //           font-family: "Noto Sans SC";
    //           font-size: 16px;
    //           font-style: normal;
    //           font-weight: 400;
    //           line-height: normal;
    //           margin-top: 10px;
    //         }
    //       }
    //     }
    //   }
    // }
    // &_button {
    //   width: 300px;
    //   height: 40px;
    //   flex-shrink: 0;
    //   border-radius: 2px;
    //   margin: 0 auto;
    //   margin-top: 16px;
    //   color: #fff;
    //   font-family: "Noto Sans SC";
    //   font-size: 14px;
    //   font-style: normal;
    //   font-weight: 400;
    //   line-height: normal;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   cursor: pointer;
    // }
  }
}
</style>
